module.exports = __webpack_public_path__ + "img/contacttop.585a6979.jpg";